import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import ScrollIndicator from "./ScrollIndicator";

export default function HeaderLight() {

  return (
    <>
      {/* Scroll Indicator */}
        <ScrollIndicator />

      {/* Header */}
      <header className="flex justify-between items-center px-4 py-4 md:px-8 shadow-md bg-white fixed top-1 left-0 right-0 z-50">
        {/* Site Title */}
        <Link to="/" className="text-purple-800 text-2xl font-bold tracking-tight">
          Sarah
        </Link>

        {/* Mobile Menu */}
        <div className="md:hidden">
          <Navbar />
        </div>

        {/* Desktop Menu */}
        <nav className="hidden md:flex gap-6 text-purple-800 font-medium text-base">
          <ul className="flex gap-6">
            <li>
              <Link to="/" className="hover:text-purple-600 transition">Home</Link>
            </li>
            <li>
              <Link to="/blog" className="hover:text-purple-600 transition">Blog</Link>
            </li>
            <li>
              <Link to="/what-i-have-been-building" className="hover:text-purple-600 transition">What I've Been Building</Link>
            </li>
            <li>
              <Link to="/about" className="hover:text-purple-600 transition">About</Link>
            </li>
            <li>
              <Link to="/contact" className="hover:text-purple-600 transition">Contact</Link>
            </li>
          </ul>
        </nav>
      </header>

      {/* Spacer to avoid content being hidden behind header */}
      <div className="h-[80px] md:h-[90px]" />
    </>
  );
}
